import React from 'react';

// General-purpose vertical list, centers child components

// Place components within VerticalList tags to use them as elements
// of the VerticalList

const VerticalList = ({ children }) => {
    return (
      <div style={{ overflow: "auto"}}>
      {/* <div style={{ height: '500px', overflow: "auto"}}> */}
        {React.Children.map(children, child => (
          <div style={{ margin: '10px 0', justifyContent: 'center'}}>
            {child}
          </div>
        ))}
      </div>
    );
};

export default VerticalList;

//style={{ height: '300px', overflowY: 'scroll' }}
//style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center'}}